<i *ngIf="iconName" nz-icon [nzType]="iconName" [nzTheme]="iconTheme"></i>